if (!customElements.get('quick-add')) {
    class QuickAdd extends HTMLElement {
        constructor() {
            super();

            this.elButton = this.querySelector('button');
            this.variantId = this.getAttribute('variant-id');

            this.elButton.addEventListener('click', this.addToCart.bind(this));
        }

        addToCart(ev) {
            ev.preventDefault();
            const elCartDrawer = document.querySelector('cart-drawer');
            elCartDrawer.addToCart(ev.currentTarget, { id: this.variantId, quantity: 1 });
        }
    }

    customElements.define('quick-add', QuickAdd);
}